// extracted by mini-css-extract-plugin
export var header = "_vw-1";
export var maskBottom = "_vw-6";
export var maskMiddle = "_vw-7";
export var maskTop = "_vw-5";
export var root = "_vw-0";
export var scrollDownButton = "_vw-3";
export var scrollDownButtonHidden = "_vw-4";
export var viewport = "_vw-2";